module.exports = "/images/LaptopSS.png?d9c1d2a85b2df4a55cd5e760849254ce";